<i class="{{ iconStyle }}" [ngClass]="icon || 'sctr-icon-check-circle-broken'"></i>
<span [tooltip]="this.text" [isTruncated]="true" [position]="position" class="{{ textStyle }}">{{ this.text | soctripTranslate | async }}</span>
